import React, { useEffect, useState } from "react";
import logo from "../components/assets/logo.svg";
import cbn from "../components/assets/cbn.svg";
import {  useNavigate } from "react-router-dom";
import InsuranceFaqModal from "../components/FAQ-insurance";
import Lottie from 'react-lottie';
import loader from "../components/anime/loading.json"; 
import loadermore from "../components/anime/loadermore.json"; 
import { getTransactionReference } from "../utils/config";
import { validateCardPayment } from "../services/interface/InterfaceService";
import { Fire } from "../utils/Fire";



const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: loader,
  color: "red",
  rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
  }
};

const defaultOptions3 = {
  loop: true,
  autoplay: true,
  animationData: loadermore,
  color: "red",
  rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
  }
};

const ComfirmationPayment = () => {
  // const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [awaiting, setIsAwaiting] = useState(false);

  const navigate = useNavigate()


 const ComfirmPayment = async () => {
  const reference = getTransactionReference() //getTransactionReference();

 try {
  setLoading(true);
  const request = {
    "transactionReference": reference
  }

  const response = await validateCardPayment(request);
  //console.log("comfirm", response)
  if(response && response?.paymentStatus?.toLowerCase() === "success"){
    Fire("success", "Payment comfirmed")

    setTimeout(() => {
      setLoading(false);
      localStorage.clear()
      navigate("/")
    }, 2000);

  } else if (response && response?.paymentStatus.toLowerCase() === "pending"){
    Fire("error", "We are awaiting your payment")
    setIsAwaiting(true)
    setLoading(false)
  } else {
   navigate("/")
   localStorage.clear()
  }
 } catch (error) {
  setLoading(false);
  localStorage.clear()
  navigate("/")
 }
}

  

  return (
    <div className="flex min-h-screen items-center justify-center bg-transparent bg-gray-600">
            <div className="rounded-lg bg-white md:w-[700px] w-full  border-[1px] border-gray-200 shadow-sm px-5 py-5 relative pb-10 mx-auto text-center">
              <div className="flex flex-col pt-5 items-center text-center justify-center md:w-[75%] w-full md:mx-auto md:my-auto md:px-10">
                <div className="self-center mb-7">
                  <img src={logo} alt="logo" />
                </div>
               
                <div className=" mx-auto p-6 flex flex-col gap-6 m-auto mt-36">
            {
              loading ? (<>
               <div className="text-center mb-6">
                   <h4 className="text-xl px-2 font-bold mt-4">
                   <Lottie
                            options={defaultOptions2}
                            height={100}
                            width={100}
                        />
                      <span className="animated-text">This will take a few seconds...</span>
                    </h4>

                  </div> 
              </>) : (
                awaiting ? <>
                 <div className="text-center mb-6">
                  <Lottie
                            options={defaultOptions3}
                            height={100}
                            width={100}
                        />
                   <h4 className="text-xl px-2 font-bold mt-4">
                        We are awaiting your payment, this may take some seconds, click continue to comfirm
                    </h4>

                  </div>
                  <button onClick={() => ComfirmPayment()} className="bg-[#161032] px-4 h-12 font-semibold md:text-lg  w-full w-100 flex items-center justify-center text-white py-3 rounded-lg mt-1 hover:bg-[red] transition ease-in-out duration-300" >{loading ? "Comfirming payment" : "Continue"}</button> 
                </> : <>
                <div className="text-center mb-6">
                  <Lottie
                            options={defaultOptions3}
                            height={100}
                            width={100}
                        />
                   <h4 className="text-xl px-2 font-bold mt-4">
                        Click the button to comfirm and continue
                    </h4>

                  </div>
                  <button onClick={() => ComfirmPayment()} className="bg-[#161032] px-4 h-12 font-semibold md:text-lg  w-full w-100 flex items-center justify-center text-white py-3 rounded-lg mt-1 hover:bg-[red] transition ease-in-out duration-300" >{loading ? "Comfirming payment" : "Continue"}</button> 
                
                </>
              ) 
            } 
                </div>
               
                <div className="text-center mt-20">
                  <p className="text-[#001F54] text-sm">Powered by</p>
                  <div className="flex items-center gap-1 mt-1">
                    <img className="w-4" src={logo} alt="cbn" />
                    <p className="text-[#001F54] text-sm font-semibold">
                      Premium<span className="text-red-500">Trust</span>Bank
                    </p>
                  </div>
                </div>
                  <InsuranceFaqModal isOpen={false}  />
                <div className="flex w-full justify-center text-center items-center gap-2 mt-12 font-medium">
                  <img src={cbn} alt="cbn" />
                  <p className="text-[#001F54] md:text-md text-sm">
                    Licensed by the Central Bank of Nigeria
                  </p>
                </div>
              </div>
            </div>
    </div>

  );
};

export default ComfirmationPayment;
